import React from 'react'
import BaseLogo from './base-logo.component'

export const Lux8000Logo = ({ fontSize }) => (
	<BaseLogo fontSize={fontSize}>
		<div className="name">lux</div>
		<div className="points blue">8000</div>
	</BaseLogo>
)
